import React from 'react'
import overlay from '../../assets/images/blue.png';

const CircleOverlay = () => {
  return (
    <>
    <div className='circleOverlay'>
        <img src={overlay} alt="circle" />
    </div>
    </>
  )
}

export default CircleOverlay